import { t as uiText } from '../../i18n';
import { deleteObject, getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from '../../lib/firebase';

const ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml', 'image/gif'];

function extensionFor(file: File): string {
  if (file.type === 'image/png') return 'png';
  if (file.type === 'image/jpeg') return 'jpg';
  if (file.type === 'image/webp') return 'webp';
  if (file.type === 'image/svg+xml') return 'svg';
  if (file.type === 'image/gif') return 'gif';
  return file.name.split('.').pop() || 'png';
}

/** 管理画面と同じ公開パスへボタン画像・アイコンを置く。 */
export async function uploadAppearanceImage(
  workspaceId: string,
  file: File,
  kind: 'button' | 'icon',
  previousUrl?: string,
): Promise<string> {
  if (file.size > 2 * 1024 * 1024) {
    throw new Error(uiText('Image files must be 2 MB or smaller.'));
  }
  if (!ALLOWED_TYPES.includes(file.type)) {
    throw new Error(uiText('Only PNG, JPG, WEBP, SVG, and GIF images are supported.'));
  }
  if (previousUrl) {
    try {
      await deleteObject(ref(storage, previousUrl));
    } catch (error) {
      console.warn('既存のウィジェット画像削除に失敗（処理継続）:', error);
    }
  }
  const storageRef = ref(
    storage,
    `${workspaceId}/public/widget/button/${kind}_${Date.now()}.${extensionFor(file)}`,
  );
  const snapshot = await uploadBytes(storageRef, file);
  return getDownloadURL(snapshot.ref);
}

export async function deleteAppearanceImage(url: string): Promise<void> {
  if (!url) return;
  try {
    await deleteObject(ref(storage, url));
  } catch (error) {
    console.warn('ウィジェット画像削除に失敗（UIは削除します）:', error);
  }
}
